<script>
  import SvelteMarkdown from 'svelte-markdown'

  //import Text from '/components/Atoms/Markdown/Text'
  import Link from '/Atoms/Markdown/Link'

  export let 
    source, // markdown string (required)
    article = false, // article means it's part of some other ibject, not standalone page
    almanac = false, // almanac style. different fonts etc
    details = false, // artwork details style
    first = false, // special styling for first block
    footnotes = false // footnote styling

  // these types are exclusive - TODO: use type const
  // const type = article ? "article" : almanac ? "almanac" : details ? "details" : "base"
  // console.log(type)

  // console.log(source)

  const renderers = {
    //text: Text,
    link: Link,
  }

  const options = {
    //breaks: true,
    smartypants: true,
    //smartLists: true,
  }

  // source += "\n"
  // source += "\n [localhost http](http://localhost:5000/123) "
  // source += "\n [slash](/123) "
  // source += "\n [invalid http](https//123) "
  // source += "\n [relative](123) "
  // source += "\n [internal domain](https://transmediale.de/123) "
  // source += "\n [external](https://example.com) "

  console.log(source.substr(0,100))

  const civicrm = source.indexOf("civicrm") > -1

  if (civicrm) {
    var CRM = {"config":{"isFrontend":false,"wysisygScriptLocation":"\/sites\/default\/modules\/civicrm\/js\/wysiwyg\/crm.ckeditor.js","CKEditorCustomConfig":{"default":"https:\/\/spot.transmediale.de\/sites\/default\/files\/civicrm\/persist\/crm-ckeditor-default.js"}}};
  }

</script>

<div class="markdown" class:article class:almanac class:details class:first class:footnotes>
  {#if source}
    {#if civicrm}
      <div class="civicrm">
        {@html source.replaceAll('"/civicrm', "\"https://spot.transmediale.de/civicrm")}
      </div>
    {:else}
      <SvelteMarkdown {source} {renderers} {options}/>
    {/if}
  {/if}
</div>

<style lang="scss" global>

  /* all this is global ^^ */
  .markdown {

    /* general */
    p {
      white-space: pre-line;
      text-align: left;
    }

    p:not(:last-child) {
      margin-bottom: 1em;
    }

    ul {
      list-style-type: disc;
      padding-left: 1em;
      margin-bottom: 1em;
    }
    
    ol {
      list-style-type: decimal;
      padding-left: 1em;
      text-align: left;
      margin-bottom: 1em;
      li {
        padding-left: 0.5ex;
      }
    }

    em {
      font-style: italic;
    }

    em + a[name^=footnote] {
      padding-left: 0.2em;
    }

    a {
      word-break: break-word;
    }

    a[name^=footnote] {
      padding-left: 0.1em;
    }

    /* all except details */

    &:not(.details) {
      strong {
        color: $color-red;
      }
    }

    /* single page */

    &:not(.article), &:not(.almanac) {

      @include typo-grotesk-text-24;

      h2, h3 {
        @include typo-serif-title-44;
        text-align: center;
        & + * {
          margin-top: 1em;
        }
      }
      h4 {
        color: $color-red;
      }

      h5 {
        @include typo-grotesk-title-captions-20;
      }

      h4 + h5 {
        margin-top: 2em;
      }

    }

    /* article (regular or almanac) */

    &.article {
      
    }

    /* article regular */

    &.article:not(.almanac) {
      @include typo-grotesk-text-24;

      h1 {
        @include typo-serif-title-44;
        text-align: center;
        & + * {
          margin-top: 1em;
        }
      }

      h2, h3 {
        color: $color-red;
        margin: 30px;
        text-align: center;
        @include typo-grotesk-text-24;
      }

      h4 {
        color: $color-red;
      }
    }

    /* almanac almanac */

    &.article.almanac {
      @include typo-serif-text-22;
    
      h1 {
        @include typo-serif-title-44;
        text-align: center;
        & + * {
          margin-top: 1em;
        }
      }

      h2, h3 {
        @include typo-serif-text-28;
        margin: 1em;
        text-align: center;
      }

      &.first p:first-of-type {
        @include typo-grotesk-text-24;
      }

      h4 {
        color: $color-red;
      }

      &.footnotes, &.footnotes * {
        @include typo-serif-caption-18;
      }
      
    }

    /* details */

    &.details {
      &, * {
      @include typo-serif-text-28;
      text-align: center;}

    }

    .civicrm {

      padding: 1em 0;

      @include typo-grotesk-text-18;
      input, select, option {
        padding: 0.5ex;
        @include typo-grotesk-text-18;
        max-width: 100%;
        box-sizing: border-box;
      }

      input[type=checkbox],
      input[type=radio] {
        height: 1em;
        width: 1em;
        padding-right: 1ex;
      }

      .description {
        font-size: 80%;
        padding: 0.5em 2em 0.5em 0;
      }

      .description + .description {
        padding-top: 0;
      }

      .crm-option-edit-link {
        display: none;
      }

      .crm-section {
        padding: 0 0 0.2em 0;
        clear: both; 
      }

      .form-item {
        display: flex;
        flex-direction: row;
        align-items: center;
      }

      .label {
        width: 10em;
        padding: 0.2em 0.2em 0.5em 0;
        box-sizing: border-box;
      }

      .edit-value {
        flex: 1;
      }

      .crm-submit-buttons {

        padding: 1ex 0;
        .button, input {
          border: solid 1px black;
          padding: 0.5em;
          display: inline-block;
          margin-right: 1em;
        }

        input {
          background-color: $color-mint;
        }
        i {
          display: none;
        }
      }

      @include media-small {
        .form-item {
          display: flex;
          flex-direction: column;
          align-items: center;
          padding-bottom: 1em;
          > * {
            width: 100%;
          }
        }
      }

      /*input[type=text],
      input[type=submit]
      select,
      button,
      .button {
        border-radius: 16px;
        border: solid 1px black;
        overflow: hidden;
      }*/
    }

  }

</style>